module.exports = __webpack_public_path__ + "static/img/2-4.e71d4b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-2/2-4.jpg
// module id = 731
// module chunks = 1